import React from 'react';
import './BarManagement.css';

function BarManagement() {
    return (
        <div className='barmanagement-outer d-flex justify-content-center align-items-center banner-bottom-radius'>
            <div className="barmanagement-inner d-flex justify-content-end align-items-start flex-column">
                <h1 className="header-text">Diploma in <br/> Hotel Management</h1>
                <p className="paragraph-text">Where Passion For Hospitality Becomes Profession.<br/> Certificate course in 3-6 months.</p>
            </div>
        </div>
    )
}

export default BarManagement
